import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "./RemovableColGrid.css";

ModuleRegistry.registerModules([AllCommunityModule]);

/**
 * A button which looks just like normal text.
 */
const InlineButton = (props) => {
  const { onClick, title, children } = props;
  return (
    <button
      className="column-tool-button"
      onClick={onClick}
      title={title}
    >
      {children}
    </button>
  );
};

/**
 * A column header with toolbar for removing and sorting columns.
 */
const RemovableHeader = (readOnly) => (props) => {
  const { displayName, column, fixedFields, onRemoveColumn, onSortColumn } = props;
  const field = column.getColDef()?.field;
  const handleRemoveClick = () => {
    if (onRemoveColumn) {
      onRemoveColumn(field);
    }
  };
  const handleClickSortAscending = () => {
    if (onSortColumn) {
      onSortColumn(field, false);
    }
  };
  const handleClickSortDescending = () => {
    if (onSortColumn) {
      onSortColumn(field, true);
    }
  };
  return (
    <div className="column-header">
      <span>{displayName}</span>
      {
        !readOnly && (
          <span className="column-tools">
            <InlineButton
              onClick={handleClickSortAscending}
              title="Sort ascending"
            >
              ▲
            </InlineButton>
            <InlineButton
              onClick={handleClickSortDescending}
              title="Sort descending"
            >
              ▼
            </InlineButton>
            {!fixedFields?.includes(field) && (
              <InlineButton
                onClick={handleRemoveClick}
                title="Remove column"
              >
                ✕
              </InlineButton>
            )}
          </span>
        )
      }
    </div>
  );
};

/**
 * An AgGridReact extended with support for removable columns.
 */
const RemovableColGrid = (props) => {
  const { onRemoveColumn, onSortColumn, columnDefs, fixedFields, readOnly, ...rest } = props;
  const decoratedColumnDefs = columnDefs?.map((columnDef) => ({
    ...columnDef,
    editable: !readOnly && columnDef.editable,
    headerComponent: RemovableHeader(readOnly),
    headerComponentParams: {
      onRemoveColumn,
      onSortColumn,
      fixedFields,
    },
  }));
  return <AgGridReact columnDefs={decoratedColumnDefs} { ...rest } />;
};

export default RemovableColGrid;
